// src/components/WaitlistForm.js
import React, { useState } from 'react';
import { joinWaitlist } from '../services/courseService';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function WaitlistForm({ courseId, onWaitlistSuccess }) {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleWaitlist = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const waitlistData = { name, email, courseId };
            await joinWaitlist(waitlistData);
            
            // Clear form and show success
            setName('');
            setEmail('');
            
            // Notify parent component
            if (onWaitlistSuccess) {
                onWaitlistSuccess();
            }
            
            // Show toast notification if available
            if (toast) {
                toast.success("Successfully joined the waitlist!");
            }
        } catch (err) {
            console.error("Waitlist failed:", err);
            setError("Failed to join waitlist. Please try again.");
            
            // Show toast notification if available
            if (toast) {
                toast.error("Failed to join the waitlist. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleWaitlist} className="bg-white p-6 shadow-lg rounded-lg w-full max-w-md mx-auto my-8">
            <h3 className="text-xl font-bold mb-4 text-gray-700">Join Waitlist</h3>
            <p className="mb-4 text-gray-600">This course is currently full. Join the waitlist to be notified when a spot becomes available.</p>

            {error && <div className="text-red-600 mb-4 p-3 bg-red-100 rounded-lg">{error}</div>}

            <div className="mb-4">
                <label className="block text-gray-700 mb-2">Name:</label>
                <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="border border-gray-300 p-2 w-full rounded"
                    required
                />
            </div>

            <div className="mb-4">
                <label className="block text-gray-700 mb-2">Email:</label>
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="border border-gray-300 p-2 w-full rounded"
                    required
                />
            </div>

            <button
                type="submit"
                className={`w-full py-2 px-4 rounded text-white ${loading ? 'bg-gray-400' : 'bg-blue-600 hover:bg-blue-700'}`}
                disabled={loading}
            >
                {loading ? "Joining Waitlist..." : "Join Waitlist"}
            </button>
        </form>
    );
}

export default WaitlistForm;